import { Section, Eyebrow } from "../funnel";

const MYTHS = [
  ["I need perfect credit first", "Not necessarily. A credit score is only one piece of the puzzle. Banks also look at your payment history, debt, income, and overall credit profile. I'll show you how to understand what lenders are looking for so you can prepare before applying."],
  ["I'll just end up in more debt", "And you shouldn't take on debt without a plan. The goal isn't to borrow money just because it's available. It's to understand how financing works, what it costs, and when using it actually makes sense for your business."],
  ["I don't have time for this", "I get it. Between work, family, and everything else, your time is valuable. That's why I'm breaking down the fundamentals in one 90-minute live training so you can understand the process and decide your next step."],
  ["I can figure it out on YouTube", "Absolutely. There's plenty of free information out there. The difference here is that I'm bringing the key pieces together into a structured framework, showing you how they connect, and giving you a chance to ask questions live."],
];

export const Myths = () => (
  <Section data-testid="myths-section">
    <Eyebrow>WHAT MIGHT BE STOPPING YOU</Eyebrow>
    <ul className="mt-10 divide-y divide-[rgba(232,184,74,0.2)] border-y border-[rgba(232,184,74,0.2)]">
      {MYTHS.map(([myth, truth], i) => (
        <li key={myth} className="grid gap-3 py-8 md:grid-cols-[2fr_3fr] md:gap-12" data-testid={`myth-row-${i + 1}`}>
          <p className="font-serif-it text-2xl leading-snug text-[#8f897e] sm:text-[28px]" data-testid={`myth-${i + 1}`}>"{myth}"</p>
          <p className="text-[16px] leading-relaxed text-[#e4dccb]">{truth}</p>
        </li>
      ))}
    </ul>
  </Section>
);
